

























import { Component, Prop, Vue } from "vue-property-decorator";
import { IBackgroundImage } from "@/@types/styles/background-image";
import { IHeightStyle } from "@/@types/styles/height";

@Component({})
export default class AlertMailDemo extends Vue {
  @Prop({ type: String, default: "" }) folder!: string;
  @Prop({ type: String, default: "" }) iconFolder!: string;
  @Prop({ type: String, default: "" }) name!: string;
  @Prop({ type: String, default: "" }) description!: string;
  @Prop({ type: String, default: "" }) background!: string;
  @Prop({ type: String, default: "" }) icon!: string;

  show = false;

  mainHeight: IHeightStyle = {
    minHeight: "auto",
    maxHeight: "auto",
  };

  get bg(): IBackgroundImage {
    return {
      backgroundImage: `url(${this.$getWebImage(
        this.background,
        this.folder + "/uhd"
      )})`,
    };
  }

  calculateHeight(): void {
    this.mainHeight.maxHeight = sessionStorage.getItem("demo-height") + "px";
    this.mainHeight.minHeight = sessionStorage.getItem("demo-height") + "px";
    this.show = true;
  }

  mounted(): void {
    this.calculateHeight();
  }
}
